module.exports = __webpack_public_path__ + "e92d7fa1d496a6c5fe75d2cdba3aac31.png";